<template>
    <Content class="invoice-col">
        <figure class="invoice-col">
            <img :data-src="product.image_main" :alt="product.pro_name_site" />
        </figure>

        <div class="product-principal-purchase content-product-wishlist">
            <h3>
                    <template v-if="showCodeOriginal">
                        {{ product.api_cod_original }} -
                    </template>
                    {{ product.pro_name_site }}
            </h3>
            <p v-if="product.color">
                <strong>Cor:</strong> {{ product.color }}
            </p>
            <p v-if="product.size">
                <strong>Tamanho:</strong> {{ product.size }}
            </p>

            <template
                v-if="
                    product.grid_group_column_value ||
                        product.grid_group_row_value
                "
            >
                <p
                    v-if="product.grid_group_column_value"
                    class="text-capitalize"
                >
                    <strong>
                        {{ product.grid_group_column_name.toLowerCase() }}:
                    </strong>
                    {{ product.grid_group_column_value }}
                </p>
                <p v-if="product.grid_group_row_value" class="text-capitalize">
                    <strong>
                        {{ product.grid_group_row_name.toLowerCase() }}:
                    </strong>
                    {{ product.grid_group_row_value }}
                </p>
            </template>
            <template v-else>
                <p>
                    {{
                        product.items_grid_abbreviaton
                            ? product.items_grid_abbreviaton
                            : product.items_grid_description
                    }}
                </p>
            </template>

            <p v-if="product.flavors">
                <strong>
                    {{ product.flavors.length > 1 ? "Sabores" : "Sabor" }}:
                </strong>
                <span
                    v-for="(flavor, idxFlavor) in product.flavors"
                    :key="`${product.purchases_products_id}-${idxFlavor}`"
                    class="purchase__flavor"
                >
                    {{ flavor.name }}
                </span>
            </p>
            <p>
                <strong>Quantidade:</strong>
                <!-- Se is_product_group usar qtd_cart -->
                {{ product.quantity }}
                {{
                    getShowUnitOfMeasureInProductPrice
                        ? product.pro_sigla_medida
                        : ""
                }}
            </p>
            <p>
                <strong>Valor:</strong>
                <!--
                    Se is_product_group
                    usar price_to ?? pro_price_site

                    product.has_childs_additionals
                        ? (product.price_to ? product.price_to : product.pro_price_site)
                        :
                 -->
                {{ currency.money(product.product_price) }}
            </p>

            <!-- LINK PDF ADICIONAL E ÍCONE DE
            IMAGEM PARA MODAL COM A IMAGEM -->
            <p v-if="product.additional_product_file" class="additional-files">
                <a
                    v-if="fileNotImage(product.additional_product_file_name)"
                    :href="product.additional_product_file"
                    target="_blank"
                >
                    <i class="fas fa-link"></i>

                    <strong>{{ product.additional_product_file_name }}</strong>
                </a>
                <i
                    v-else
                    class="far fa-image"
                    @click="handleOpenModalImage(product)"
                ></i>
            </p>

            <p v-if="product.additional_product_observation">
                {{ product.additional_product_observation }}
            </p>
        </div>

        <div
            v-if="children && children.length"
            class="product-children-purchase"
        >
            <div
                v-for="(child, keyChild) in children"
                :key="`${child.uuid}-${keyChild}`"
                class="product-child-purchase"
            >
                <figure>
                    <img
                        :data-src="child.image_main"
                        :alt="child.pro_name_site"
                    />
                </figure>
                <div>
                    <p>
                        <strong>{{ child.pro_name_site }}</strong>
                    </p>
                    <p>
                        <strong>Quantidade:</strong>
                        {{
                            product.has_childs_additionals
                                ? child.quantity
                                : child.qtd_cart
                        }}
                    </p>
                    <p v-if="product.has_childs_additionals">
                        <strong>Valor:</strong>
                        {{
                            currency.money(
                                child.price_to
                                    ? child.price_to
                                    : child.product_price
                            )
                        }}
                    </p>
                </div>
            </div>
        </div>
    </Content>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Content } from "./style";
import Currency from "../../../../helpers/parseCurrency";

export default {
    name: "PurchaseItem",
    props: {
        product: {
            required: true
        },
        children: {
            default: null
        }
    },
    components: {
        Content
    },
    data() {
        return {
            currency: Currency
        };
    },
    methods: {
        ...mapActions("modalCarousel", ["setImagesModalCarousel"]),
        fileNotImage(file_name) {
            return (
                file_name.search(/.+\.pdf$/) >= 0 ||
                file_name.search(/.+\.cdr$/) >= 0 ||
                file_name.search(/.+\.psd$/) >= 0
            );
        },
        handleOpenModalImage(product) {
            let images = [
                {
                    image: product.additional_product_file,
                    alt: product.pro_name_site
                }
            ];
            this.setImagesModalCarousel(images);
            this.$root.showModalApp("modal_carousel_images");
        }
    },
    computed: {
        ...mapGetters("company", [
            "showCodeOriginalBesideDescription",
            "getShowUnitOfMeasureInProductPrice"
        ]),
        showCodeOriginal() {
            return (
                this.showCodeOriginalBesideDescription &&
                this.product.api_cod_original
            );
        }
    }
};
</script>
